import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import RequireAuth from './RequireAuth';
export default function RequireAdmin({ children }) {
    const { user } = useAuth();
    return <RequireAuth>{user?.isAdmin ? children : <Navigate to="/" replace />}</RequireAuth>;
}
